import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const CreditsTileWrapper = styled(NavLink)`
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px ${({ theme }) => theme.color.shadow};
  transition: transform 0.2s;
  cursor: pointer;
  text-decoration: none;
  width: 208px;
  height: 100%;
  padding: 12px;
  margin: 0px;
  font-size: 25px;

  &:hover {
    transform: translateY(-7px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.beneathFullHD}px) {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.horizontalMobile}px) {
    grid-template-columns: 2fr;
    justify-content: center;
    padding: 8px;
  }
`;

export const CreditsTileImage = styled.div`
  width: 100%;
  display: block;
  aspect-ratio: 2 / 3;
  border-radius: 5px;
  background-size: cover;
  background-position: center;
  background-color: transparent;
  margin: 0 auto 16px auto;
  background-image: ${({ $posterUrl, $noPosterUrl }) =>
    `url(${$posterUrl || $noPosterUrl})`};

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    aspect-ratio: 2 / 3;
    margin: 0;
  }
`;

export const CreditsTileContainer = styled.header`
    font-size: 22px;
`

export const CreditsTileName = styled.h2`
  display: flex;
  text-align: center;
  justify-content: center;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 500;
  color: ${({ theme }) => theme.color.woodsmoke};

  @media (max-width: ${({ theme }) => theme.breakpoint.beneathFullHD}px) {
        font-size: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletLandscape}px) {
        font-size: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
        font-size: 14px;
        margin: 5px 0;
  }

@media (max-width: 540px) {
        font-size: 8px;
        margin: 5px 0;
  }`;

export const CreditsTileJob = styled.h2`
  display: flex;
  text-align: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.3;
  color: ${({ theme }) => theme.color.grey};

  @media (max-width: ${({ theme }) => theme.breakpoint.beneathFullHD}px) {
        font-size: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletLandscape}px) {
        font-size: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
        font-size: 14px;
        margin: 5px 0;
  }

  @media (max-width: 540px) {
        font-size: 8px;
        margin: 5px 0;
}`;